<!--
 * @Author: your name
 * @Date: 2020-08-13 20:52:36
 * @LastEditTime: 2022-10-31 11:14:49
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/order-history/index.vue
-->
<style lang="sass" scoped>
.enter_phone_number
  display: flex
  justify-content: center
  margin-top: 32px
  font-size: 12px
  color: rgba(51, 68, 85, .75)

  .body_box
    display: flex
    flex-direction: column
    align-items: center
    width: 241px

    .icon_container
      display: flex
      justify-content: center
      align-items: center
      height: 67px
      width: 67px
      background-color: #EFEFF0
      border-radius: 50%

      .icon
        height: 43px

    .title
      margin-top: 18px
      font-size: 16px
      font-weight: bold
      color: #334455

    .text
      margin-top: 14px
      text-align: center

    .code
      display: flex !important
      justify-content: space-between !important
      align-items: center !important
      height: 54px !important
      width: 100% !important
      margin-top: 18px !important
      margin-bottom: 20px !important
      flex-direction: row !important
      flex-wrap: nowrap !important

.button_box
  display: flex
  flex-direction: column
  align-items: center
  width: 100%

  .button
    margin-top: 20px
    width: 100%
    height: auto
    border: none
    padding: 0 80PX
    border-radius: 5PX !important
    font-size: 14PX
    height: 54PX

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
</style>

<template lang="pug">
  .enter_phone_number
    .body_box
      .icon_container
        img.icon(:src="lockSrc")
      .title {{ t('verification_code', 'Verification code') }}
      .text {{ t('enter_verification_code', 'Please enter the verification code sent') }}
      p to {{ phoneNumber }}
      otp-input.code(v-model="code")
      .button_box
        van-button.button.b(type="primary" :disabled="disabled" @click="submit") {{ t('submit', 'SUBMIT') }}
        van-button.button.b(type="primary" :disabled="!!time" @click="sendVerificationCode") {{ t('resend', 'RESEND') }} {{ showTime }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState } from 'vuex'
import { restoreUser } from '@/api/product'
import { t } from '@/utils/language'

const TIME = 60

@Component({
  computed: {
    ...mapState(['venueId'])
  },

  watch: {
    code(val) {
      this.disabled = val.length !== 4
    }
  },
})

class verificationCode extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  lockSrc = require('@/assets/pay-methods/tab-user-lock.png')
  disabled = true
  code = ''
  phoneNumber = ''
  userCode = ''
  countryCode = ''
  userInfo = null
  time = TIME

  created() {
    this.phoneNumber = decodeURIComponent(this.$route.query.phoneNumber)
    this.userCode = decodeURIComponent(this.$route.query.userCode)
    this.countryCode = decodeURIComponent(this.$route.query.countryCode)
    this.hasUser = !!localStorage.getItem('userId')
  }

  mounted() {
    this._countdown()
  }

  get showTime() {
    return this.time ? ` (${this.time}s)` : ''
  }

  async sendVerificationCode() {
    try {
      this.$store.commit('showLoading')
      await restoreUser({
        action: 'sendVerificationCode',
        phone: this.phoneNumber,
        countryCode: this.countryCode
      })
      this.$store.commit('closeLoading')
      this.time = TIME
      this._countdown()
    } catch (error) {
      this.$store.commit('closeLoading')
    }
  }

  async submit() {
    try {
      this.$store.commit('showLoading')
      const res = await restoreUser({
        action: 'verifyUser',
        phone: this.phoneNumber,
        code: this.code,
        countryCode: this.countryCode
      })
      // If there is no userId locally, save the userId locally
      // 若本地没有 userId，把 userId 存到本地
      if (!this.hasUser) {
        localStorage.setItem('userId', res.id)
        this.$store.commit('addUserProp', {
          prop: 'id',
          val: res.id
        })
      }
      // Save userPhone locally
      // 把 userPhone 存到本地
      this.$store.commit('saveUserPhone', res.phone)
      // Save userCode locally
      // 把 userCode 存到本地
      this.$store.commit('saveUserCode', '+' + this.userCode.trim())
      this.$store.commit('closeLoading')
      this.$router.push({
        name: 'order-history',
        query: {
          isVerificationCode: true
        }
      })
    } catch (error) {
      this.$store.commit('closeLoading')
    }
  }

  _countdown() {
    this.timer = setInterval(() => {
      this.time--
      if (this.time === 0) clearInterval(this.timer)
    }, 1000)
  }
}

export default verificationCode
</script>
